export default "__VITE_ASSET__BkDB6ehj__"